export class EnaioAddonAddWfOrg {
    displayMask = "";
    showVirtualRoles = false;
    showProcessRoles = false;
}
